import { ChevronRight } from 'lucide-react';

/**
 * Page header: breadcrumb-style eyebrow, title, optional subtitle and actions.
 * Deliberately flat — the old gradient icon chip competed with page content.
 */
export default function PageHeader({ icon: Icon, eyebrow, title, subtitle, actions, className = '' }) {
  return (
    <div className={`mb-5 flex flex-wrap items-start justify-between gap-3 ${className}`}>
      <div className="min-w-0">
        {eyebrow && (
          <p className="mb-1 flex items-center gap-1 text-2xs font-semibold uppercase tracking-wider text-content-subtle">
            {eyebrow}
            <ChevronRight size={11} className="opacity-60" />
          </p>
        )}
        <h1 className="flex items-center gap-2.5 truncate text-xl font-bold tracking-tight text-content">
          {Icon && (
            <span className="mod-icon flex h-8 w-8 shrink-0 items-center justify-center rounded-lg">
              <Icon size={17} strokeWidth={2.2} />
            </span>
          )}
          {title}
        </h1>
        {subtitle && <p className="mt-1 text-sm text-content-muted">{subtitle}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}
